import {
  BookOpen,
  ChartColumnIncreasing,
  CreditCard,
  House,
  NotebookPen,
  NotepadText,
  Settings,
} from "lucide-react";
import Sidebar from "../../../components/ui/SideBar";

export default function LecturerSidebar({ children }) {
  const sidebarLinks = [
    {
      title: "Dashboard",
      icon: <House className="w-5 h-5" />,
      href: "/lecturer/dashboard",
    },
    {
      title: "Courses",
      icon: <BookOpen className="w-5 h-5" />,
      href: "/lecturer/courses",
    },
    {
      title: "Topics",
      icon: <NotepadText className="w-5 h-5" />,
      href: "/lecturer/topics",
    },
    {
      title: "Quizzes",
      icon: <NotebookPen className="w-5 h-5" />,
      href: "/lecturer/quizzes",
    },
    {
      title: "Analytics",
      icon: <ChartColumnIncreasing className="w-5 h-5" />,
      href: "/lecturer/analytics",
    },
    {
      title: "Subscription",
      icon: <CreditCard className="w-5 h-5" />,
      href: "/lecturer/subscription",
    },
    {
      title: "Settings",
      icon: <Settings className="w-5 h-5" />,
      href: "/lecturer/settings",
    },
  ];

  return <Sidebar sidebarLinks={sidebarLinks}>{children}</Sidebar>;
}
